// extracted by mini-css-extract-plugin
module.exports = {"prayerContainer":"page_prayerContainer__GAzf1"};